import { loadMember, loadMemberRewards } from '@vista-digital/occ-domain'

export type JobType = 'loyalty-reset'
export type TaskMap = { [k in JobType]?: () => void }

export const tasksMap: TaskMap = {
    'loyalty-reset': () => {
        void loadMember(true)
        void loadMemberRewards(true)
    },
}
